import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-business')) {
  pageBusiness()
}
function pageBusiness() {
  let caseSlider = []
  const caseSliderItem = document.getElementsByClassName('js-caseSlider')
  if (caseSliderItem[0]) {
    for (const targetSlider of caseSliderItem) {
      const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
      caseSliderInit(targetSlider, sliderName)
    }
  }
  function caseSliderInit(targetSlider, sliderName) {
    caseSlider[sliderName] = new Swiper(targetSlider, {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },

      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
      },
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })
  }
}
